<template lang='pug'>
  #default-layout
    #view-container(
      :class="{ inactive: mode.modal }"
      @click='left = !left'
    )
      //- #serp-container.view.with-header(v-if='query')
      //-   bf-wrapper.content
      //-     h5.heading Search Results for "{{ query }}"
      //-     .businesses
      //-       router-link.business(
      //-         v-for='biz, i in businesses'
      //-         v-if='biz.name'
      //-         :to='{ name: "merchant", params: {id: biz.id} }'
      //-       )
      //-         bf-divider.card
      //-         h6.name {{ biz.name }}
      //-         p.desc {{ biz.description }}

      slot( :scrolled='scrolled' )

    merchant-nav#merchant-nav(
      :user='user'
      :account='account'
      :left='left'
      :scrolled='scrolled'
    )
</template>

<script>
  import { View, Animatable } from '@/mixins/view'
  import { db } from '@/main'
  import MerchantNav from '@/components/merchant-nav'

  export default {
    name: 'default.layout',

    mixins: [ View, Animatable ],

    components: {
      MerchantNav
    },

    data() {
      return {
        left: false,
        query: '',
        businesses: [],
        scrolled: false,
        mode: { modal: false }
      }
    },

    firestore() {
      return {
        businesses: db.collection('businesses')
      }
    },

    watch: {
      // account(curr, prev) {
      //   if ( curr.id ) {
      //     if ( !curr.congratulated ) {
      //       if ( curr.merchant && !prev.merchant ) {
      //         this.mode.modal = true
      //         db.collection('accounts').doc(curr.id).update({ congratulated: true })
      //       }
      //     }
      //   }
      // }
    },

    methods: {
      transition(to) {
        this.mode.modal = false
        this.$router.push(to)
      },

      search(query) {
        this.query = query
      },

      scrollable() {
        if ( window.scrollY ) this.scrolled = true
        else this.scrolled = false
      }
    },

    created() {
      window.addEventListener( 'scroll', this.scrollable )
    },

    destroyed() {
      window.removeEventListener( 'scroll', this.scrollable )
    }
  }

</script>

<style scoped lang="stylus">
  #view-container.inactive
    overflow hidden
    max-height 100vh

  #view-container
    padding-top 49px
    padding-bottom 64px
    
  .v-leave
    //

  .v-leave-to
    transform rotateY(-180deg)
    opacity 0
    transition all 360ms

  .v-enter
    opacity 0
    transform rotateY(180deg)

  .v-enter-to
    opacity 1
    transform rotateY(0deg)
    transition all 360ms

  .flip-leave
    //

  .flip-leave-to
    transform rotateY(-180deg)
    opacity 0
    transition all 360ms

  .flip-enter
    opacity 0
    transform rotateY(180deg)

  .flip-enter-to
    opacity 1
    transform rotateY(0deg)
    transition all 360ms

  // #serp-container
  //   position absolute
  //   z-index 2
  //   min-height 100%
  //   width 100%
  //   background white
  //   box-sizing border-box
  //   padding-bottom 88px
  //   .business .name
  //     display block
  //     color inherit
  //   @media(min-width: 1080px)
  //     width calc( 100% - var(--width-nav) )
  //   .desc
  //     margin-top 8px
  //     font-size .88em
</style>
